/* __next_internal_client_entry_do_not_use__ SearchProductTileClickProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useProductLinkProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/useProductLinkProps";
import { ProductTileClickContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { useOnProductClickForSearchPage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
export var SearchProductTileClickProvider = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, impressionId = _param_data.impressionId, images = _param_data.images, isPromoted = _param_data.isPromoted, promotedBy = _param_data.promotedBy, badgeList = _param_data.badgeList, brandToken = _param_data.brandToken, selectedProductOptionToken = _param_data.selectedProductOptionToken, bestImage = _param_data.bestImage, children = param.children;
    var onProductClick = useOnProductClickForSearchPage({
        token: productToken,
        isPromoted: isPromoted,
        impressionId: impressionId,
        promotedBy: promotedBy,
        badgeList: badgeList,
        bestImage: bestImage,
        images: images
    }).onProductClick;
    var productLinkProps = useProductLinkProps({
        token: productToken,
        brandToken: brandToken,
        impressionId: impressionId,
        selectedProductOptionToken: selectedProductOptionToken
    });
    return /*#__PURE__*/ _jsx(ProductTileClickContext.Provider, {
        value: {
            productLinkProps: productLinkProps,
            onProductClick: onProductClick
        },
        children: children
    });
};
